import { render, staticRenderFns } from "./AddSeguroistatuPage.vue?vue&type=template&id=7a696536"
import script from "./AddSeguroistatuPage.vue?vue&type=script&lang=js"
export * from "./AddSeguroistatuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports